import type { ReactNode } from 'react';
import styled from 'styled-components';
import { Header } from '@components/layout/Header';
import { Footer } from '@components/layout/Footer';

const Main = styled.main`
  /* Empurra o conteúdo abaixo do header fixo. */
  padding-top: ${({ theme }) => theme.layout.headerHeightMobile};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding-top: ${({ theme }) => theme.layout.headerHeight};
  }
`;

interface PageLayoutProps {
  children: ReactNode;
  /** Se true, o conteúdo começa no topo da tela (para heroes que precisam ir embaixo do header transparente). */
  heroMode?: boolean;
}

/**
 * Layout base de todas as páginas.
 * Injeta Header fixo + Footer.
 * Em `heroMode`, remove o padding-top para que a seção hero
 * fique por trás do header transparente — efeito cinematográfico.
 */
export function PageLayout({ children, heroMode = false }: PageLayoutProps) {
  return (
    <>
      <Header />
      <Main style={heroMode ? { paddingTop: 0 } : undefined}>
        {children}
      </Main>
      <Footer />
    </>
  );
}
